export type CTAActionType =
  | "generate_chapter"
  | "rewrite_chapter"
  | "generate_character"
  | "generate_worldbuilding"
  | "generate_synopsis"
  | "rewrite_synopsis"
  | "generate_outline"
  | "rewrite_outline"
  | "generate_trait"
  | "rewrite_trait"
  | "generate_worldbuilding_trait"
  | "rewrite_worldbuilding_trait"
  | "generate_cast";

export type CTAActionStatus = "awaiting_input" | "in_progress" | "cancelled" | "completed";

export type CTAAction = {
  type: CTAActionType;
  status: CTAActionStatus;
  targetSurface?: "story_bible_outline_summary";
  targetId?: string;
  targetName?: string;
  displayTitle: string;
  userMessage: string;
  cannedResponse: string;
  customInstructions?: string;
  /** generate_outline only: OUTLINE_FRAMWORKS value (e.g. "novel-outline", "custom-outline"). */
  outlineFramework?: string;
  signalKey?: string;
  characterId?: string;
  entryId?: string;
  traitId?: string;
  traitLabel?: string;
  role?: string;
  roleLabel?: string;
  roleExplicitlySelected?: boolean;
  /**
   * Set once this activation's instant-fire Go has dispatched (generate_cast stays
   * awaiting_input after firing, so a CTAInputBody remount would otherwise re-send).
   */
  instantFired?: boolean;
};

/**
 * Content equality for CTA actions (flat, primitive-valued). Treats a field explicitly
 * set to undefined the same as an absent field, so re-spreads like
 * `{ ...action, role: undefined }` compare equal to the original.
 */
export function ctaActionsEquivalent(a: CTAAction | null, b: CTAAction | null): boolean {
  if (a === b) return true;
  if (!a || !b) return false;
  const keys = new Set([...Object.keys(a), ...Object.keys(b)]) as Set<keyof CTAAction>;
  for (const key of keys) {
    if (!Object.is(a[key], b[key])) return false;
  }
  return true;
}
